import { render } from "./TariffsView.vue?vue&type=template&id=b22666d4"
import script from "./TariffsView.vue?vue&type=script&lang=js"
export * from "./TariffsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__